export default "__VITE_ASSET__BMr7G3P0__"